import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class CommonService {
  errorData: {};

  constructor(private http: HttpClient) {}

  redirectUrl: string;

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error("An error occurred:", error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    this.errorData = {
      errorTitle: "Oops! Request for document failed",
      errorDesc: "Something bad happened. Please try again later.",
    };
    return throwError(this.errorData);
  }

  /*DashBoard Page Data API */
  getStateCity(zip: any) {
    let link =
      "https://maps.googleapis.com/maps/api/geocode/json?address=" +
      zip +
      "&region=US&key=AIzaSyBsU_jEPk7ximrROYqknRZHTLZ8U9B0r0I";
    //console.log('link', link);
    return this.http.post<any>(link, "").pipe(
      map((user) => {
        //console.log('test', user);
        return user;
      }),
      catchError(this.handleError)
    );
  }

  getAuthenticationFromServer(refNo) {
    //let link = "https://10.1.2.61:8009/api/CompanyRegistration/"+refNo
    //let link = "https://localhost:44352/api/CompanyRegistration/"+refNo;
    let link =
      "https://clientsignuptest.hunterwarfield.com/ClientSignUpTestAPI/api/CompanyRegistration/" +
      refNo;
    //console.log('link', link);
    return this.http.get(link).pipe(catchError(this.handleError));
  }

  /*DashBoard Page Data API */
  PostSubmitRegistration(registrationFormData) {
    let link =
      "https://clientsignuptest.hunterwarfield.com/ClientSignUpTestAPI/api/CompanyRegistration";
    //console.log('link', link);

    let httpOptions = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };

    return this.http.post<any>(link, registrationFormData, httpOptions).pipe(
      map((submittedData) => {
        //console.log('test', user);
        return submittedData;
      }),
      catchError(this.handleError)
    );
  }

  isRegistered() {
    if (localStorage.getItem("setContractPage") == "1") {
      return true;
    }
    return false;
  }

  isFirstRegistrationDone() {
    if (localStorage.getItem("firstRegistrationDetails") != null) {
      return true;
    }
    return false;
  }

  isAppFolioFistRegistrationDone() {
    const formData = localStorage.getItem("appfolioFirstRegistrationDetails");
    if (formData != null && formData != undefined) {
      return true;
    }
    return false;
  }

  getHttpRequestForUploadDoc(url: string, requestMethod, body?: any) {
    console.log(requestMethod);
    console.log(body);
    console.log(url);

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization:
          "Bearer 3AAABLblqZhCpbyU_a84r5yEreBYEnDINGmXRnAERbW4TLtskpIDG8pUaxseqi_VlRrmNt_MSwxf7Z_zzC89lP2_wbISqn7CU",
        "Content-Type": "application/json",
      }),
    };

    //show the loader before starting the request
    //  let loader = this.showLoader();
    //this.http.setDataSerializer('json');
    return this.http.post(url, body, httpOptions).pipe(
      map((agreementId) => {
        console.log("agreementId", agreementId);
        return agreementId;
      }),
      catchError(this.handleError)
    );
  }
}
